module.exports = __webpack_public_path__ + "static/media/studio_bookings.55a61e96.svg";